<template>
  <button v-on:click="go($event)">
    <p>
      <img :class="color" v-if="image" :src="imagePath" width="20" height="20" />
      {{ text.toUpperCase() }}
      <span class="bold">{{ bold.toUpperCase() }}</span>
    </p>
  </button>
</template>

<script>
export default {
  props: ['text', 'href', 'image', 'bold', 'color'],
  computed: {
    imagePath() {
      return require(`../../assets/${this.image}`);
    },
  },
  methods: {
    go() {
      if (!this.href) {
        this.$emit('go');
        return;
      }

      this.$router.push(this.href).catch(err => {
        this.$log.error(err);
      });
    },
  },
};
</script>

<style scoped>
button {
  color: black;
  line-height: 22px;
  letter-spacing: 0.46px;
  font-weight: 300;
  width: 230px;
  padding-left: 20px;
  height: 60px;
  font-size: 16px;
  background-color: rgba(13, 82, 160, 0.1);
  border: none;
  margin: auto;
  cursor: pointer;
  border: none;
  transition: width 0.5s; /* Animation */
}
button:hover {
  width: 350px;
}
p {
  position: absolute;
  top: 0;
  margin: 18px;
  left: 0;
  width: 340px;
}
.bold {
  font-weight: 600;
}
@supports (-moz-appearance: none) {
  .bold {
    font-weight: 500;
  }
}
img {
  float: left;
}
.white {
  filter: brightness(0) invert(1);
}
/*
résolution moins de 1280
*/
@media (max-width: 1280px) {
  button {
    width: 50px;
  }
  button:hover {
    width: 250px;
  }
  p {
    width: 220px;
    margin: 10px;
  }
}
</style>
